import { colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { Typography as T } from 'common/typography';

type StepperProps = {
  currentStep: number;
};

const Root = styled.div`
  padding: 24px 32px;
  display: flex;
  gap: 8px;
`;

const RoundIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const LineSeparator = styled.div`
  height: 2px;
  min-width: 100px;
  width: 100%;
`;

const StepNumber = styled(T.Heading6)`
  /* ignore-color */
  color: ${colors.salt100};
`;
const StepTitle = styled(T.Body2)`
  font-weight: 700;
`;

type ContainerProps = {
  $stepStatus: 'current' | 'completed' | 'unreached';
};

const containerModifiers = {
  current: () => css`
    ${RoundIcon} {
      background-color: ${colors.wolt100};
    }
    ${LineSeparator} {
      background-color: ${colors.wolt100};
    }
  `,
  completed: () => css`
    ${RoundIcon} {
      background-color: ${colors.lime100};
    }
    ${LineSeparator} {
      background-color: ${colors.lime100};
    }
  `,
  unreached: () => css`
    ${RoundIcon} {
      background-color: ${cssThemedValue({ dark: colors.salt64, light: colors.pepper8 })};
    }
    ${StepNumber} {
      /* ignore-color */
      color: ${colors.pepper64};
    }
    ${StepTitle} {
      font-weight: 500;
      color: ${cssThemedValue({ dark: colors.salt64, light: colors.pepper64 })};
    }
  `,
};

const Container = styled.div<ContainerProps>`
  ${({ $stepStatus }) => css`
    display: flex;
    width: 100%;
    align-items: center;
    gap: 8px;
    white-space: nowrap;

    ${containerModifiers[$stepStatus]}
  `}
`;

export const Stepper = ({ currentStep }: StepperProps) => {
  return (
    <Root>
      <Container $stepStatus={currentStep === 1 ? 'current' : 'completed'}>
        <RoundIcon>
          <StepNumber>1</StepNumber>
        </RoundIcon>
        <StepTitle>
          <FormattedMessage id="shared-menu.editor.importer.stepper.from-sheets" />
        </StepTitle>
        <LineSeparator />
      </Container>
      <Container $stepStatus={currentStep === 2 ? 'current' : 'unreached'}>
        <RoundIcon>
          <StepNumber>2</StepNumber>
        </RoundIcon>
        <StepTitle>
          <FormattedMessage id="shared-menu.editor.importer.stepper.preview" />
        </StepTitle>
      </Container>
    </Root>
  );
};
